import { Button, Stack, Typography } from '@mui/material'

export default function AutomationSetupBlockers({ blockers, retry, retrying }) {
  return (
    <Stack spacing={1}>
      {blockers.map((blocker) => (
        <Typography key={`${blocker.code}:${blocker.trigger_id}`} color="error">
          {blocker.message}
        </Typography>
      ))}
      <Button variant="outlined" disabled={retrying} onClick={retry}>
        {retrying ? 'Retrying trigger setup…' : 'Retry trigger setup'}
      </Button>
    </Stack>
  )
}
